import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { FullPageSpinner } from "../common/Spinner/FullPageSpinner";
import { Button } from "../common/Button";
import { AWS_S3_PUBLIC_BUCKET } from "../../environment";

const PrivacyPolicyModal = ({ handleShow, handleClose }) => {
  const [fullPageLoader, setFullPageLoader] = useState(false);
  const [privacyStatement, setPrivacyStatement] = useState(null);

  useEffect(() => {
    if (handleShow) {
      fetchPrivacyPolicy();
    }
  }, [handleShow]);

  const fetchPrivacyPolicy = async () => {
    try {
      setFullPageLoader(true);

      const url =
        `https://${AWS_S3_PUBLIC_BUCKET}.s3.amazonaws.com/privacy-policy.html`;

      const response = await fetch(url);
      if (!response.ok) {
        throw new Error("Failed to fetch privacy policy data");
      }

      const html = await response.text();
      setPrivacyStatement(html);
    } catch (error) {
      console.error("Error loading privacy policy:", error);
      setPrivacyStatement(
        "Failed to load privacy policy data. Please try again later."
      );
    } finally {
      setFullPageLoader(false);
    }
  };

  return (
    <>
      {fullPageLoader && <FullPageSpinner loadingText="Loading..." />}
      <Modal
        size="xl"
        show={handleShow}
        onHide={handleClose}
        aria-labelledby="contained-modal-title-vcenter"
        backdrop="static"
        centered
        className="custom-dialog popup-org"
        dialogClassName="wide-modal"
      >
        <Modal.Header closeButton className="border-0">
          <Modal.Title id="contained-modal-title-vcenter">
            Fonemed Privacy Policy
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div dangerouslySetInnerHTML={{ __html: privacyStatement }} />
          <div className="action-wrap">
            

            <Button
              onClick={handleClose}
              variant="secondary"
              title="Cancel"
            >
              Close
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PrivacyPolicyModal;
